module.exports = __webpack_public_path__ + "static/media/app-condutor-icone-ios.37013f75.webp";